import autoTable from 'jspdf-autotable';
// HELPERS
import returnDataToString from '../../../helpers/returnDataToString';

// UTILS
import sortAlphaUTL from '../../../../../utils/sortAlphaUTL';
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';
import infoMsg from '../../../helpers/infoMsg';
import title from '../../../helpers/title';

const returnedData = (doc, data, info, docStyles) => {
  const { Response } = data;

  title(
    doc,
    docStyles,
    'Returned Data',
    docStyles.headers.secondary,
    docStyles.separation
  );

  const columns = [
    { header: '', dataKey: 'col1' },
    {
      header: '',
      dataKey: 'col2',
    },
  ];
  const rows = [];

  // DATA SOURCES
  let visaEntitlement = Response.serviceResponses['Australia Visa Entitlement'];
  let residentialLookup = Response.serviceResponses['Australia Residential Lookup'];
  let visa = Response.serviceResponses['Australia Government Identity Documents 4'];
  let residential = Response.serviceResponses['Australia Residential'];
  let propertyOwnership = Response.serviceResponses['Australia Property Ownership'];
  let medicareCard =
    Response.serviceResponses['Australia Government Identity Documents 3'];
  let driverLicence =
    Response.serviceResponses['Australia Government Identity Documents 1'];
  let passport = Response.serviceResponses['Australia Government Identity Documents 2'];
  let centerlinkCard =
    Response.serviceResponses['Australia Government Identity Documents 5'];
  let birthCertificate =
    Response.serviceResponses['Australia Government Identity Documents 6'];
  let creditBureau = Response.serviceResponses['Australia Credit Bureau'];
  let citizens = Response.serviceResponses['Australia Citizens'];
  let payroll = Response.serviceResponses['Australia Payroll'];
  let superannuation = Response.serviceResponses['Australia Superannuation'];
  let deathCheck = Response.serviceResponses['Australia Death Check'];
  let watchlistAML = Response.serviceResponses['Watchlist AML'];

  if (visaEntitlement) {
    let { returnedData, verifications, ...data } = visaEntitlement;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Visa Entitlement',
      col2: string,
    });
  } else {
    visaEntitlement = { verifications: {}, returnedData: {} };
  }

  if (residentialLookup) {
    let { returnedData, verifications, ...data } = residentialLookup;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Residential Lookup',
      col2: string,
    });
  } else {
    residentialLookup = { verifications: {} };
  }

  if (visa) {
    let { returnedData, verifications, ...data } = visa;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Visa',
      col2: string,
    });
  } else {
    visa = { verifications: {}, returnedData: {} };
  }

  if (residential) {
    let { returnedData, verifications, ...data } = residential;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Residential',
      col2: string,
    });
  } else {
    residential = { verifications: {}, returnedData: {} };
  }

  if (propertyOwnership) {
    let { returnedData, verifications, ...data } = propertyOwnership;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Property Ownership',
      col2: string,
    });
  } else {
    propertyOwnership = { verifications: {}, returnedData: {} };
  }

  if (medicareCard) {
    let { returnedData, verifications, ...data } = medicareCard;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Medicare Card',
      col2: string,
    });
  } else {
    medicareCard = { verifications: {}, returnedData: {} };
  }

  if (driverLicence) {
    let { returnedData, verifications, ...data } = driverLicence;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Driver Licence',
      col2: string,
    });
  } else {
    driverLicence = { verifications: {}, returnedData: {} };
  }

  if (passport) {
    let { returnedData, verifications, ...data } = passport;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Passport',
      col2: string,
    });
  } else {
    passport = { verifications: {}, returnedData: {} };
  }

  if (centerlinkCard) {
    let { returnedData, verifications, ...data } = centerlinkCard;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Centrelink Card',
      col2: string,
    });
  } else {
    centerlinkCard = { verifications: {}, returnedData: {} };
  }

  if (birthCertificate) {
    let { returnedData, verifications, ...data } = birthCertificate;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Birth Certificate',
      col2: string,
    });
  } else {
    birthCertificate = { verifications: {}, returnedData: {} };
  }

  if (creditBureau) {
    let { returnedData, verifications, ...data } = creditBureau;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Credit Bureau',
      col2: string,
    });
  } else {
    creditBureau = { verifications: {}, returnedData: {} };
  }

  if (citizens) {
    let { returnedData, verifications, ...data } = citizens;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Citizens',
      col2: string,
    });
  } else {
    citizens = { verifications: {}, returnedData: {} };
  }

  if (payroll) {
    let { returnedData, verifications, ...data } = payroll;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Payroll',
      col2: string,
    });
  } else {
    payroll = { verifications: {}, returnedData: {} };
  }

  if (superannuation) {
    let { returnedData, verifications, ...data } = superannuation;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Superannuation',
      col2: string,
    });
  } else {
    superannuation = { verifications: {}, returnedData: {} };
  }

  if (deathCheck) {
    let { returnedData, verifications, ...data } = deathCheck;

    const string = returnDataToString({
      fields: { ...data, ...verifications, ...returnedData },
    });

    rows.push({
      col1: 'Australia Death Check',
      col2: string,
    });
  } else {
    deathCheck = { verifications: {}, returnedData: {} };
  }

  // WATCHLIST AML
  let watchlistAMLPaddingTrigger = false;
  if (watchlistAML) {
    let { returnedData, verifications, ...data } = watchlistAML;

    if (isEmptyVAL(returnedData.watchlistResults)) {
      returnedData = { watchlistResults: [{}] };
    }

    const fields = returnDataToString({
      fields: {
        ...data,
        ...verifications,
        ...returnedData.watchlistResults[0],
      },
    });

    rows.push({
      col1: 'Global Watchlist AML',
      col2: fields,
    });
  } else {
    watchlistAML = {
      returnedData: { watchlistResults: [{}] },
      verifications: {},
    };
  }

  rows.sort((a, b) => sortAlphaUTL(a, b, 'col1'));

  const finalY = (doc.lastAutoTable.finalY || 40) + docStyles.tableYFromTitle;

  autoTable(doc, {
    columns: columns,
    body: rows,
    didParseCell: (data) => {
      const { cell, column } = data;
      cell.styles.fillColor = [255, 255, 255];
      if (column.raw.dataKey === 'col1') {
        cell.styles.textColor = docStyles.colorGreen;
      }

      if (column.index === 0) {
        cell.styles.cellPadding = { top: 60, bottom: 60, left: 3.75, right: 3.75 }; // This should prevent second column inner contents from overflowing
      }

      if (cell.raw === 'Watchlist AML') {
        if (watchlistAMLPaddingTrigger) {
          cell.styles.cellPadding = { top: 125, bottom: 125 }; // This should prevent second column inner contents from overflowing
        }
      }
    },
    showHead: 'never',
    styles: {
      textColor: docStyles.colorText,
      ...docStyles.tableStyles,
    },
    columnStyles: {
      col1: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
        cellWidth: docStyles.cellWidth,
      },
      col2: {
        font: docStyles.fontFamily.arialUnicodeMS,
        textColor: docStyles.colorText,
      },
    },
    startY: finalY,
  });

  infoMsg(
    doc,
    docStyles,
    [{ header: '', dataKey: 'col1' }],
    [
      {
        col1: 'Name Match Score: A=Full Match | A1=Middle Name Mismatched | B=First Initial and Surname Matched | C=Surname Only Match | X=No Match',
      },
      {
        col1: 'Address Match Score: 0=Full Match | 1=Suburb/Postcode Mismatch | 2=Unit # Mismatch | 2A=House Suf/Prefix Mismatch | 3=Street # Mismatch | Z=No Match',
      },
    ],
    docStyles.separation
  );
};

export default returnedData;
